const SENTENCE = 0
const COMMON = 1
const DEFAULT = 2

export default {SENTENCE, COMMON, DEFAULT}



// WEBPACK FOOTER //
// ./src/lib/AnswerTypes.js